<template>
  <div :style="cssVars()">
    <div class="new-task">
      <div class="daily-tasks">
        <div class="title">
          <span>{{ $t('lang.task.newHostressTask') }}</span>
          <i v-if="total">{{ total.reward }}/{{ total.total }}</i>
          <img :src="getMatchImg('beans')" alt="" />
        </div>
        <!-- 倒计时 -->
        <div class="clock">
          <img src="@/assets/packageAssets/views/P1_Girls/HostessTasks/default/clock2.png" alt="" />
          <span>{{ transformSeconds1(newerTaskTimeSeconds) }}</span>
        </div>
        <div class="list-box">
          <div class="daily-task-list" v-for="(item, index) in newerTask" :key="index">
            <div v-if="bubbleShow && item.customState === 1 && index === 0" class="bubble-tips">
              <div class="bubble-content">
                <span>{{ $t('lang.commonM.k113') }}</span>
                <div class="bubble-tran"></div>
              </div>
            </div>
            <div class="left-btn-text">
              <span class="text">{{ handleTitle1(item.title) }}</span>
              <!-- 点击 按钮 -->
              <!-- 多个条件节点 -->
              <div class="left-btn" v-if="item.conditions && item.conditions.length > 1">
                <div class="left-btn-box left-nav arrow" v-if="handleStatus(item.conditions) == 0" @click="handleArrow(item)">
                  <img src="@/assets/packageAssets/views/P1_Girls/HostessTasks/default/arrow.png" alt="" />
                </div>

                <div class="left-btn-box left-nav success" v-if="handleStatus(item.conditions) == 1" @click="handleRward(item, 'new')">
                  {{ $t('lang.commonM.k073') }}
                </div>

                <div class="left-btn-box left-nav checked" v-if="handleStatus(item.conditions) == 2">
                  <img src="@/assets/packageAssets/views/P1_Girls/HostessTasks/default/check.png" alt="" />
                </div>
              </div>
              <!-- 一个条件节点 -->
              <div class="left-btn" v-else>
                <div class="left-btn-box left-nav arrow" v-if="item.conditions[0].state == 0" @click="handleArrow(item)">
                  <img src="@/assets/packageAssets/views/P1_Girls/HostessTasks/default/arrow.png" alt="" />
                </div>
                <div class="left-btn-box left-nav success" v-if="item.conditions[0].state == 1" @click="handleRward(item, 'new')">
                  {{ $t('lang.commonM.k073') }}
                </div>
                <div class="left-btn-box left-nav checked" v-if="item.conditions[0].state == 2">
                  <img src="@/assets/packageAssets/views/P1_Girls/HostessTasks/default/check.png" alt="" />
                </div>
              </div>
            </div>
            <div class="time-num-money">
              <span>{{ handleTitle2(item.title) }}</span>
              <div class="btn-num" v-if="item.conditions && item.conditions.length == 1">
                {{ item.conditions[0].rewardList[0].rewardPropNum }}
                <img :src="getMatchImg('beans')" alt="" />
              </div>
            </div>
            <!-- 进度条有多个状态的 -->
            <div class="progress-three" v-if="item.conditions && item.conditions.length > 1">
              <div class="progress-line ar-rogress-line">
                <div class="node">
                  <div class="node-item" :class="{ arNodeItem: $i18n.locale != 'ar' }"></div>
                  <template v-for="(child, index) in item.conditions">
                    <template v-if="$i18n.locale != 'ar'">
                      <div
                        :key="index"
                        class="node-item"
                        :class="{ taskSuccess: child.state == 2, checked: child.state == 1 }"
                        :style="{ left: `${child.goal / handleComputeNodeValue(item.conditions)}%` }"
                      >
                        <div class="node-top">
                          <div>
                            {{ child.rewardList[0].rewardPropNum }}
                            <img :src="getMatchImg('beans')" alt="" />
                          </div>
                        </div>
                        <div class="node-bottom">
                          {{ child.goalDisplay }}
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        :key="index"
                        class="node-item"
                        :class="{ taskSuccess: child.state == 2, checked: child.state == 1 }"
                        :style="{ right: `${child.goal / handleComputeNodeValue(item.conditions)}%` }"
                      >
                        <div class="node-top">
                          <div>
                            {{ child.rewardList[0].rewardPropNum }}
                            <img :src="getMatchImg('beans')" alt="" />
                          </div>
                        </div>
                        <div class="node-bottom">
                          {{ child.goalDisplay }}
                        </div>
                      </div>
                    </template>
                  </template>
                </div>
                <van-progress
                  class="progress-bar"
                  :class="{ arProgressBar: $i18n.locale == 'ar' }"
                  track-color="#ffffff"
                  :show-pivot="true"
                  :pivot-text="threeMaxProc(item.conditions)"
                  :percentage="handleComputeProgress(item.conditions)"
                  stroke-width="4"
                />
              </div>
            </div>
            <!-- 进度条 Online Call -->
            <div class="online-call ar-online-call" v-if="item.conditions && item.conditions.length == 1">
              <div class="progress-bar-box progress-bar-box-online" v-if="item.conditions[0].targetOnlineTimeRangeSeconds">
                <span>{{ $t('lang.task.online') }}</span>
                <van-progress
                  class="progress-bar"
                  :class="{ arProgressBar: $i18n.locale == 'ar' }"
                  track-color="#ffffff"
                  :show-pivot="true"
                  :pivot-text="item.conditions[0].onlineTimeRangeSecondsDisplay"
                  :percentage="handlePercentageOnlineCall(item.conditions[0].onlineTimeRangeSeconds, item.conditions[0].targetOnlineTimeRangeSeconds)"
                  stroke-width="4"
                />
                <div class="state-number">
                  <div
                    class="state-number-box"
                    :class="{
                      arStateNumberBox: $i18n.locale == 'ar',
                      arStateNumberSuccess: $i18n.locale == 'ar',
                      stateNumberSuccess: handlePercentageOnlineCall(item.conditions[0].onlineTimeRangeSeconds, item.conditions[0].targetOnlineTimeRangeSeconds) >= 100
                    }"
                  >
                    <span>{{ handleSecondsHours(item.conditions[0].targetOnlineTimeRangeSeconds) }}{{ $t('lang.task.hrs') }}</span>
                  </div>
                </div>
              </div>
              <div class="progress-bar-box" v-if="item.conditions[0].targetCallTimeRangeSeconds">
                <span>{{ $t('lang.earnRule.callDuration') }}</span>
                <van-progress
                  class="progress-bar"
                  :class="{ arProgressBar: $i18n.locale == 'ar' }"
                  track-color="#ffffff"
                  :show-pivot="true"
                  :pivot-text="item.conditions[0].callTimeRangeSecondsDisplay"
                  :percentage="handlePercentageOnlineCall(item.conditions[0].callTimeRangeSeconds, item.conditions[0].targetCallTimeRangeSeconds)"
                  stroke-width="4"
                />
                <div class="state-number">
                  <div
                    class="state-number-box"
                    :class="{
                      arStateNumberBox: $i18n.locale == 'ar',
                      arStateNumberSuccess: $i18n.locale == 'ar',
                      stateNumberSuccess: handlePercentageOnlineCall(item.conditions[0].callTimeRangeSeconds, item.conditions[0].targetCallTimeRangeSeconds) >= 100
                    }"
                  >
                    <span>{{ handleSecondsMinutes(item.conditions[0].targetCallTimeRangeSeconds) }}{{ $t('lang.task.mins') }}</span>
                  </div>
                </div>
              </div>
              <!-- 只有一条进度的不分段 -->
              <div class="progress-bar-box" v-if="!item.conditions[0].targetCallTimeRangeSeconds">
                <van-progress
                  class="progress-bar"
                  :class="{ arProgressBar: $i18n.locale == 'ar' }"
                  track-color="#ffffff"
                  :show-pivot="true"
                  :pivot-text="threeMaxProc(item.conditions)"
                  :percentage="(item.conditions[0].proc / item.conditions[0].goal) * 100"
                  stroke-width="4"
                />
                <div class="state-number">
                  <div
                    class="state-number-box ar-state-numbre-box"
                    :class="{
                      arStateNumberBox: $i18n.locale == 'ar',
                      arStateNumberSuccess: $i18n.locale == 'ar',
                      stateNumberSuccess: item.conditions[0].goal == item.conditions[0].proc
                    }"
                  >
                    <span>{{ item.conditions[0].goalDisplay }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <van-popup class="van-popup-box" v-model="showRewardDia" @close="closeShowRewardDia" :lock-scroll="false">
          <div class="reward-dia">
            <img class="bulibuli" :src="getMatchImg('reward-bg')" alt="" />
            <span class="number">x{{ rewardNumber }}</span>
          </div>
          <div class="reward-dia-btn">
            <span @click="handleRewardDiaConfirm">{{ $t('lang.confirm') }}</span>
          </div>
        </van-popup>

        <van-popup class="van-popup-task-finish" v-model="showNewTaskFinishDia" @close="handleNewTaskFinishDia" :lock-scroll="false">
          <div class="task-finish-title">
            {{ $t('lang.giftSign.congratulations') }}
          </div>
          <div class="task-finish-content">
            {{ $t('lang.task.congratulationsCon') }}
          </div>
          <div class="reward-dia-btn">
            <span @click="handleNewTaskFinishDia">{{ $t('lang.gotit') }}</span>
          </div>
        </van-popup>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin } from '../mixin.js'
import { pageCssVars } from '../z-style-cfg.js'

export default {
  props: {
    newerTask: [],
    newerTaskTimeSeconds: {
      type: Number
    }
  },
  mixins: [mixin, pageCssVars],
  data() {
    return {}
  },
  created() {
    this.getTotalNum(this.newerTask)
  },
  methods: {
    // 关闭新手任务完成任务提示弹窗
    handleNewTaskFinishDia() {
      this.showNewTaskFinishDia = false
      this.$parent.fetchHostessTaskPage()
    }
  },
  watch: {
    newerTask(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.total = this.taskTotal(newVal)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  display: flex;
  align-items: flex-end;
  font-family: Inter-Regular;
  font-weight: 600;
  font-size: 20px;
  color: #333333;
  i {
    display: block;
    margin: 0 2px 0 8px;
    font-weight: 500;
    font-size: 12px;
    color: var(--theme-title-count-color);
  }
  img {
    width: 13px;
    height: 13px;
  }
}

.right-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  .btn {
    margin-bottom: 10px;
  }
  .btn {
    width: 70px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(90deg, #cccbd0 0%, #bfbcc3 100%);
    border-radius: 16px;
    font-size: 18px;
    color: #fff;
    .arrow {
      width: 18px;
      height: 18px;
    }
  }
  .btn-num {
    display: flex;
    align-items: center;
    height: 16px;
    font-family: Inter-Regular;
    font-weight: 500;
    font-size: 12px;
    color: #999999;
    line-height: 16px;
    > img {
      width: 13px;
      margin: 0 2px;
    }
  }
}

.progress-bar {
  border-radius: 20px;
  ::v-deep .van-progress__portion {
    background: var(--theme-progress-color) !important;
  }
}
</style>
<style lang="less" scoped>
.daily-tasks {
  font-family: Inter-Regular;
  .list-box {
    position: relative;
  }
  .daily-task-list {
    position: relative;
    z-index: 10;
    width: 100%;
    padding: 12px 0 1px;
    background: var(--theme-task-list-bg);
    border-radius: 8px;
    margin: 10px 0;
    .left-btn-text,
    .time-num-money {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .left-btn-text {
      margin-bottom: 4px;
      font-family: Inter-Medium;
      color: #333333;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      padding: 0 12px;
      .left-btn {
        min-width: 70px;
        height: 24px;
        .left-btn-box {
          width: 100%;
          height: 100%;
          padding: 0 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 16px;
          > img {
            width: 18px;
            height: 18px;
          }
        }
        .arrow {
          background: var(--theme-arrow-btn-bg);
        }
        .success {
          background: var(--theme-success-btn-bg);
          color: #fff;
        }
        .checked {
          background: linear-gradient(90deg, #cccbd0 0%, #bfbcc3 100%);
        }
      }
    }
    .time-num-money {
      display: flex;
      align-items: center;
      font-family: Inter-Regular;
      font-size: 12px;
      color: #999999;
      line-height: 20px;
      padding: 0 12px;
      .btn-num {
        display: flex;
        align-items: center;
        > img {
          width: 13px;
          margin: 0 2px;
        }
      }
    }
    // 有三段的进度条
    .progress-three {
      width: 100%;
      margin: 10px auto;
      position: relative;
      .progress-num {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 16px;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        line-height: 16px;
        > div {
          display: flex;
          align-items: center;
          img {
            width: 14px;
          }
        }
      }
    }
    .progress-line {
      width: 100%;
      padding: 24px 32px 20px 20px;
      .node {
        position: relative;
        width: 100%;
        display: flex;
        .node-item {
          position: absolute;
          z-index: 100;
          top: 0;
          transform: translateY(-30%);
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: var(--theme-node-bg);
          .node-top {
            position: absolute;
            top: -14px;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #999999;
            font-size: 12px;
            > div {
              display: flex;
              align-items: center;
              > img {
                width: 13px;
                margin: 0 2px;
              }
            }
          }
          .node-bottom {
            position: absolute;
            top: 23px;
            left: 50%;
            z-index: 10;
            transform: translate(-50%, -50%);
            font-size: 10px;
            color: #333333;
          }
        }
        .node-item:nth-child(1) {
          background-color: rgba(255, 255, 255, 0);
          left: 0;
        }
        .node-item:nth-child(2) {
          left: 33.3%;
        }
        .node-item:nth-child(3) {
          left: 66.6%;
        }
        .node-item:nth-child(4) {
          left: 99.4%;
        }

        .arNodeItem:nth-child(1) {
          background-color: rgba(255, 255, 255, 0);
          left: auto !important;
          right: 0 !important;
        }

        .taskSuccess {
          width: 12px;
          height: 12px;
          background: var(--theme-success-icon);
          background-size: 100% 100%;
        }
        .checked {
          width: 12px;
          height: 12px;
          background: url('~@/assets/packageAssets/views/P1_Girls/HostessTasks/default/checked_icon.png');
          background-size: 100% 100%;
        }
      }
    }
  }
  .glass-view {
    filter: blur(4px);
    -webkit-filter: blur(4px);
  }
  // 只有一个进度条的
  .online-call {
    padding: 10px 30px 10px 20px;
  }
  .progress-bar-box {
    position: relative;
    width: 100%;
    margin: 0 0 22px;
    > span {
      display: block;
      margin-bottom: 5px;
      font-family: Inter-Regular;
      font-weight: 400;
      font-size: 10px;
      color: #333333;
      line-height: 12px;
    }
    .state-number {
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      position: relative;
      .state-number-box {
        display: flex;
        align-items: center;
        flex-direction: column;
        position: absolute;
        top: -6px;
        left: 100%;
        width: 8px;
        height: 8px;
        margin-left: -4px;
        border-radius: 50%;
        background-color: var(--theme-node-bg);
        > span {
          position: absolute;
          top: 16px;
          font-family: Inter-Regular;
          font-weight: 500;
          font-size: 10px;
          color: #333333;
          line-height: 12px;
        }
      }
      .stateNumberSuccess {
        top: -8px;
        left: 99.4%;
        width: 12px;
        height: 12px;
        background: var(--theme-success-icon);
        background-size: 100% 100%;
      }
      .arStateNumberBox {
        left: auto !important;
        right: 99.4% !important;
      }
      .arStateNumberSuccess {
        left: auto !important;
        right: 99.4% !important;
      }
    }
  }
  .progress-bar-box-online {
    margin: 0 0 30px;
  }
  .progress-bar {
    border-radius: 20px;
    ::v-deep .van-progress__portion {
      background: var(--theme-progress-color) !important;
    }
  }
}
::v-deep .van-popup {
  background-color: transparent;
}
.van-popup-box {
  width: 350px;
  padding: 0px 20px 40px;
  overflow: hidden;
}
.reward-dia {
  width: 300px;
  height: 300px;
  margin: 0 auto;
  position: relative;
  font-family: Inter-Regular;
  overflow: hidden;
}

.bulibuli {
  display: block;
  width: 300px;
  height: 300px;
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  margin-left: -150px;
  margin-top: -150px;
}
.number {
  position: absolute;
  z-index: 20;
  top: 55%;
  left: 50%;
  transform: translate(-50%, 0);
  display: block;
  margin-top: 30px;
  font-family: Inter-Bold;
  font-size: 45px;
  color: #ffac00;
  text-stroke: 1px #ffffff;
  -webkit-text-stroke: 1px #ffffff;
}
.reward-dia-btn {
  width: 100%;
  color: var(--theme-reward-btn-color);
  font-size: 16px;
  font-family: Inter-Regular;
  text-align: center;
  > span {
    padding: 8px 30px;
    margin: 0 auto;
    line-height: 40px;
    border-radius: 20px;
    background: var(--theme-reward-btn-bg);
  }
}
.van-popup-task-finish {
  width: 300px;
  padding: 30px 20px;
  background: #ffffff;
  border-radius: 12px;
  font-family: Inter-Regular;
  background-color: #fff;
  .task-finish-title {
    width: 100%;
    text-align: center;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
    line-height: 26px;
  }
  .task-finish-content {
    width: 100%;
    margin: 20px 0;
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }
}

.bubble-tips {
  position: absolute;
  top: -40px;
  right: 0;
  min-width: 180px;
  padding: 0 10px;
  line-height: 32px;
  border-radius: 6px;
  background-color: #333333;
  .bubble-content {
    width: 100%;
    height: 100%;
    text-align: center;
    position: relative;
    span {
      font-family: RobotoFlex-Regular;
      font-weight: 400;
      font-size: 15px;
      color: #e6e5e7;
      line-height: 18px;
      text-align: center;
    }
    .bubble-tran {
      position: absolute;
      right: 20%;
      bottom: -8px;
      z-index: -1;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-top: 10px solid #333333;
    }
  }
}

::v-deep .van-progress__pivot {
  position: absolute;
  z-index: 1000 !important;
  top: calc(50% + 3px);
  left: 100% !important;
  transform: translate(-50%, 50%) !important;
  background-color: var(--theme-pivot-color) !important;
  border-radius: 2px;
  min-width: 20px;
  &::after {
    content: '';
    position: absolute;
    left: 50%;
    top: -3px;
    z-index: -1;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 4px solid var(--theme-pivot-color);
  }
}

.arProgressBar {
  ::v-deep .van-progress__pivot {
    position: absolute;
    z-index: 1000 !important;
    top: calc(50% + 3px);
    left: auto !important;
    background-color: var(--theme-pivot-color) !important;
    right: 100% !important;
    transform: translate(50%, 50%) !important;
    border-radius: 2px;
    min-width: 20px;
    &::after {
      content: '';
      position: absolute;
      left: 50%;
      top: -3px;
      z-index: -1;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 4px solid var(--theme-pivot-color);
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .online-call {
    padding: 10px 20px 10px 30px !important;
  }
  .progress-line {
    padding: 24px 20px 20px 32px !important;
  }
  .bubble-tips {
    left: 0 !important;
    right: auto !important;
    .bubble-content {
      .bubble-tran {
        left: 20% !important;
        right: auto !important;
      }
    }
  }
}
</style>
<style lang="less" scoped>
.new-task {
  .clock {
    display: flex;
    align-items: center;
    margin: 6px 0 20px;
    font-family: Inter-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 16px;
    img {
      width: 14px;
      height: 14px;
    }
    > span {
      padding: 0 5px;
    }
  }

  .upload {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 343px;
    padding: 12px;
    margin-bottom: 20px;
    background: var(--theme-task-list-bg);
    border-radius: 8px;
    .task-tit {
      font-size: 14px;
      color: #333333;
      line-height: 17px;
    }
  }
}
</style>
